import { Component } from '@angular/core';

import { QuoteEstimateBaseComponent } from '@accuservpro/xplat/features';

@Component({
    selector: 'accuservpro-quote-estimate',
    templateUrl: 'quote-estimate.component.html',
    standalone: false
})
export class QuoteEstimateComponent extends QuoteEstimateBaseComponent {
  constructor() {
    super();
  }
}
